const Colors = {
    primaryColorLight: "#69C5ED",
    primaryColor: "#2F80ED",
    secondaryColor: "#EB861A",
    lightGrey: "#C5CAE9",
    green: "#2e7d32",
    orange: "#EB861A",
    black: "rgba(0, 0, 0, 0.87)",
    grey: "#4f4f4f",
}

export default Colors
